import { apiFetch } from '@/lib/api/http';

/** 監査ログ検索（指示書 §5.1・§8・§12 M11 / DECISIONS D-044）. */
export interface AuditLog {
  id: string;
  actor_user_id: string | null;
  actor_name: string | null;
  actor_role: string | null;
  action: string;
  resource_type: string;
  resource_id: string | null;
  before: Record<string, unknown> | null;
  after: Record<string, unknown> | null;
  reason: string | null;
  ip: string | null;
  user_agent: string | null;
  at: string;
}

export interface Page<T> {
  items: T[];
  total: number;
  page: number;
  per_page: number;
}

export interface AuditLogQuery {
  page?: number;
  per_page?: number;
  // 未指定は undefined を渡す（exactOptionalPropertyTypes のため型にも明示する）
  actor_user_id?: string | undefined;
  action?: string | undefined;
  resource_type?: string | undefined;
  resource_id?: string | undefined;
  date_from?: string | undefined;
  date_to?: string | undefined;
}

export function fetchAuditLogs(query: AuditLogQuery = {}): Promise<Page<AuditLog>> {
  const params = new URLSearchParams();
  if (query.page) params.set('page', String(query.page));
  if (query.per_page) params.set('per_page', String(query.per_page));
  if (query.actor_user_id) params.set('actor_user_id', query.actor_user_id);
  if (query.action) params.set('action', query.action);
  if (query.resource_type) params.set('resource_type', query.resource_type);
  if (query.resource_id) params.set('resource_id', query.resource_id);
  if (query.date_from) params.set('date_from', query.date_from);
  if (query.date_to) params.set('date_to', query.date_to);
  const search = params.toString();
  return apiFetch<Page<AuditLog>>(`/audit-logs${search ? `?${search}` : ''}`);
}
